export default __webpack_public_path__ + "static/plusmeta_Logo_Quanos_web_weiß_svg-4100fdad61859e186e12076ac29dab9e.svg";